import AgyleHeader from '../../components/header/agyleHeader/agyleHeader';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import {AgyleTable, createAgyleTableColumn} from '../../components/table/AgyleTable';
import React, {Fragment, useEffect, useRef, useState} from 'react';
import {
    loadWardPatientsByWardId,
    updatePatientData,
    updateWardPatientsByWardId,
    wardPatients,
} from '../../store/reducers/ward';
import _ from 'lodash';
import moment from 'moment/moment';
import Paper from '@mui/material/Paper';
import AgyleSelectField from '../../components/ui/selector/agyleSelectField';
import useOpenState from '../../hooks/useOpenState';
import IconButton from '@mui/material/IconButton';
import ClinicalConclusion from '../ward/forms/clinicalConclusion';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import {hasOneOfPermission, hasPermission, Permissions, sendUserAudit} from '../../store/reducers/user';
import {setSnackbar} from '../../store/reducers/globals';
import {TimerCountUp} from '../../controls/agyle/timer';
import PatientAlarms from '../ward/forms/alarms/patientAlarms';
import {addNotesForPatient} from '../../store/reducers/notes';
import {FormLabel, Grid, Tooltip} from '@mui/material';
import clsx from 'clsx';
import {arrivalModes, referredToService} from '../../store/reducers/dicts';
import ReferralsForm from '../ward/forms/referralsForm';
import {UtilsMomentJS} from '../../store/utilsMoment';
import {getZoneAndBedsNameFromOldMapUHD} from '../../util/oldMapUtil';
import {handleListName} from '../ward/dashboard';
import useDict from '../../hooks/useDict';
import MenuItem from '@mui/material/MenuItem';
import Notes from '../../util/notes';
import CsmFrom from '../ward/forms/csm/csmFrom';
import uuidv4 from 'uuid/v4';
import API from '../../app/api';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import MessageBox from '../../util/messageBox';
import AgyleDictionaryField from '../../components/ui/selector/agyleDictionaryField';
import NotificationsIcon from '@mui/icons-material/Notifications';
import EmptyDiagnosisDialog from '../utils/emptyDiagnosisDialog';
import InformationBox from '../../components/other/informationBox';
import AgyleDatePicker from '../../components/ui/fields/agyleDatePicker';
import AgyleButton from '../../components/ui/buttons/agyleButton';
import ClearIcon from '@mui/icons-material/Clear';
import {ReferredToService} from '../../controls/agyle/ecds';
import {calculateArrivalDate} from '../../util/patientUtil';
import {getPatientFlagValue} from '../ward/mainScreen/util/patientFlagsUtil';
import {getReferralsColor} from '../../controls/agyle/tasks/taskUtil';
import {getCSMFormName, getFacility, getInfectionIcon} from '../ward/forms/formsUtil';
import {useHistory} from 'react-router-dom';
import {getConfig} from '../../util/configUtil';
import MiniFormDialog from '../../components/modal/miniFormDialog';
import {patientBanner} from '../../controls/agyle/tasks/components/patientBanner';
import { AUDIT_TYPES } from '../../util/auditUtil';

const useStyles = makeStyles((theme) => ({
    hospital: {
        marginLeft: 'auto',
        fontSize: 'large',
        fontStyle: 'italic',
        fontWeight: 'bold',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: 10,
        padding: 10,
        margin: '0 10px',
        marginTop: 15,
    },
    csmButton: {
        border: 'solid 2px',
        borderRadius: 10,
        padding: 3,
        fontSize: 'small',
        fontWeight: 'bold',
    },
    topIcon: {
        display: 'inline-block',
        '& svg': {
            color: '#DC4A5D',
        },
        '&.none': {
            '& svg': {
                color: '#01af69',
            },
        },
        '&.confirm': {
            '& svg': {
                color: '#DC4A5D',
            },
        },
        '&.suspected': {
            '& svg': {
                color: '#FEB03A',
            },
        },
    },
    referral: {
        display: 'inline-block',
        width: 40,
        margin: 1,
        height: 30,
        textAlign: 'center',
        lineHeight: '30px',
        color: '#fff',
        borderRadius: 10,
        fontSize: 'small',
        '&.completed': {
            border: '2px solid #000',
            color: '#000',
            lineHeight: '25px',
        },
    },
    iconButton: {
        margin: -5,
    },
    colorSystem: {
        width: 16,
        height: 16,
        backgroundColor: 'white',
        display: 'inline-block',
        verticalAlign: 'middle',
        border: '1px solid #222',
    },
    centerRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    dictFont: {
        fontSize: 'small',
        paddingLeft: 0,
    },
}));

const PT_OPT = [
    {name: 'Both', id: 'both'},
    {name: 'ED', id: 'ed'},
    {name: 'Other', id: 'other'},
];

const BED_STATUS_OPT = [
    {name: 'Requested', id: 'Requested'},
    {name: 'Ready', id: 'Ready'},
    {name: 'Allocated', id: 'Allocated'},
    {name: 'Canceled', id: 'Canceled'},
];

const TIMESTAMP = [
    createAgyleTableColumn('timestamp', 'Timestamp', 3, 'timestamp', 'dateDefault', '', 'medium', 'left', true, true, 250, null, ['forceShow']),
];

const BOOKING_COLUMNS = [
    createAgyleTableColumn('count', 'No', 1, 'count', 'string', 'notSort', 'medium', 'center', true, true, null, null),
    createAgyleTableColumn('Status', 'Status', 2, 'status', 'bedBookingButton', '', 'medium', 'center', true, true, null, null, ['bedStatus']),
    createAgyleTableColumn('link', 'Link', 3, 'link', 'object', '', 'medium', 'left', true, true, null, null),
    createAgyleTableColumn('ptName', 'Name', 4, 'ptName', 'string', '', 'medium', 'left', true, true, null, 200),
    createAgyleTableColumn('hospNo', 'Hospital No', 5, 'hospNo', 'string', '', 'medium', 'left', true, true, null, 110),
    createAgyleTableColumn('gender', 'Gender', 6, 'gender', 'string', '', 'medium', 'left', true, true, null, null),
    createAgyleTableColumn('age', 'Age', 7, 'age', 'string', '', 'medium', 'left', true, true, null, null),
    createAgyleTableColumn('type', 'Type', 8, 'type', 'bbType', '', 'medium', 'center', true, true, null, 100),
    createAgyleTableColumn('site', 'Current Site', 9, 'site', 'bedBookingButton', '', 'medium', 'center', true, true, null, 120, ['siteStatus']),
    createAgyleTableColumn('zone', 'Zone', 10, 'zone', 'string', '', 'medium', 'left', true, true, null, 175),
    createAgyleTableColumn('bed', 'Bed', 11, 'bed', 'string', '', 'medium', 'left', true, true, null, 100),
    createAgyleTableColumn('obs', 'Obs Score', 12, 'obs', 'obsEmpty', '', 'medium', 'left', true, true, null, 35),
    createAgyleTableColumn('time', 'Time in Department', 13, 'time', 'timeEmpty', '', 'medium', 'left', true, false, null, 100),
    createAgyleTableColumn('timeReferral', 'Time since Referral', 14, 'timeReferral', 'timeEmpty', '', 'medium', 'left', true, false, null, 110),
    createAgyleTableColumn('timeAllocated', 'Time since Bed Ready', 14, 'timeReady', 'timeEmpty', '', 'medium', 'left', true, false, null, 110),
    createAgyleTableColumn('timeBedWait', 'Time of Bed Wait', 15, 'timeBedWait', 'timeBedWait', '', 'medium', 'left', true, false, null, 100),
    createAgyleTableColumn('destination', 'Destination', 16, 'destination', 'bedBookingButton', '', 'medium', 'left', true, true, null, 100, ['siteStatus']),
    createAgyleTableColumn('speciality', 'Speciality', 17, 'speciality', 'bedBookingButton', '', 'medium', 'left', true, true, null, 140),
    createAgyleTableColumn('activity', 'ECDS Activity Treatment', 18, 'activity', 'object', '', 'medium', 'left', true, true, null, 300),
    createAgyleTableColumn('resForAdmit', 'Reason for Admission', 19, 'resForAdmit', 'bedBookingButton', '', 'medium', 'left', true, true, null, 200),
    createAgyleTableColumn('patientPost', 'Patient Post Take Comp.', 20, 'patientPost', 'bedBookingButton', '', 'medium', 'left', true, true, null, 120),
    createAgyleTableColumn('dependency', 'Care', 21, 'dependency', 'object', '', 'medium', 'left', true, true, null, null),
    createAgyleTableColumn('sideRoom', 'Side Room', 22, 'sideRoom', 'bedBookingButton', '', 'medium', 'left', true, true, null, 150),
    createAgyleTableColumn('infections', 'Infection Control', 23, 'infections', 'bedBookingButton', '', 'medium', 'left', true, true, null, null),
    createAgyleTableColumn('onHoldWard', 'On Hold Ward', 24, 'onHoldWard', 'bedBookingButton', '', 'medium', 'left', true, true, null, 90),
    createAgyleTableColumn('edNote', 'ED Note', 25, 'edNote', 'bedBookingButton', '', 'medium', 'left', true, true, null, 200),
    createAgyleTableColumn('ward', 'Ward', 26, 'ward', 'bedBookingButton', '', 'medium', 'left', true, true, null, 250),
    createAgyleTableColumn('wardFeedback', 'Ward Feedback', 27, 'wardFeedback', 'bedBookingButton', '', 'medium', 'left', true, true, null, 250),
    createAgyleTableColumn('withinHour', 'Within an hour', 28, 'withinHour', 'bedBookingButton', '', 'medium', 'left', true, true, null, 250),
    createAgyleTableColumn('conclusion', 'Conclusion', 29, 'conclusion', 'bedBookingButton', '', 'medium', 'left', true, true, null, 170, ['conclusionStatus']),
    createAgyleTableColumn('readyNote', 'Ready Description', null, 'readyNote', 'bedBookingButton', '', 'medium', 'left', true, true, null, 170),
    createAgyleTableColumn('canceledNote', 'Canceled Description', null, 'canceledNote', 'bedBookingButton', '', 'medium', 'left', true, true, null, 170),
    createAgyleTableColumn('onHoldWardNote', 'On Hold Ward Description', null, 'onHoldWardNote', 'bedBookingButton', '', 'medium', 'left', true, true, null, 200),
    createAgyleTableColumn('patientPostNote', 'Patient Post Take Complete Description', null, 'patientPostNote', 'bedBookingButton', '', 'medium', 'left', true, true, null, 200),
];

const BedBookingTable = ({open, onClose}) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const {t} = useTranslation();
    const history = useHistory();

    // Configs
    const uhdMaps = getConfig('modules.map.customMapConfig', []);
    const ecdsDateTimeFormat = getConfig('ecdsDateTimeFormat', 'YYYY-MM-DDTHH:mm:ss');
    const diagnosisRequiredDialog = getConfig('diagnosisRequiredDialog', false);

    const HOSPITAL_OPT = [
        {name: 'Both Hospitals', id: 'both'},
    ];
    uhdMaps.forEach(map => HOSPITAL_OPT.push({name: map?.name, id: map?.hospitalId}));

    // Map load
    const refContainer = useRef(null);
    const refContainerElement = useRef(null);
    const [zones, setZones] = useState([]);

    const wardPatientsObject = useSelector(wardPatients);
    const [otherSitePts, setOtherSitePts] = useState([]);
    const dictReferredToService = useSelector(referredToService);

    const [destination, setDestination] = useState(HOSPITAL_OPT[0].id);
    const [ptReferred, setPtReferred] = useState('both');
    const [specialty, setSpecialty] = useState([]);
    const [bedStatus, setBedStatus] = useState('');
    const [currentSiteFilter, setCurrentSiteFilter] = useState(null);

    const [ptsObject, setPtsObject] = useState([]);

    // Load arrival mode for ambulance handover
    const dictArrivalMode = useSelector(arrivalModes);
    const [arrivalMode, setArrivalMode] = useState([]);

    // Form open state
    const saveType = useRef(null);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [isCSMOpen, openCSM, closeCSM] = useOpenState(false, true);
    const [isCurrentSiteOpen, openCurrentSite, closeCurrentSite] = useOpenState(false, true);
    const [isClinicalConclusionOpen, openClinicalConclusion, closeClinicalConclusion] = useOpenState(false, true);
    const [isAlarmOpen, openAlarm, closeAlarm] = useOpenState(false, true);
    const [isReferralsOpen, openReferrals, closeReferrals] = useOpenState(false, true);
    const [isPatientContextOpen, openPatientContext, closePatientContext] = useOpenState(false, true);
    const [isDischargeOpen, openDischarge, closeDischarge] = useOpenState(false, true);
    const [isEmptyDiagnosisDialogOpen, openEmptyDiagnosisDialog, closeEmptyDiagnosisDialog] = useOpenState(false, true);

    // Dicts
    const [triageDependencies] = useDict('TriageDependencies', '__code');
    const [sdecSitesDict, sdecSitesDictLoading] = useDict('SdecSites');
    const [activityTreatment, activityTreatmentLoading] = useDict('ActivityTreatment', null);
    const [currentSiteBedBooking, currentSiteBedBookingLoading] = useDict('CurrentSitesBedBooking');

    // Admitted patients
    const [toggleAdmitted, setToggleAdmitted] = useState(false);
    const [admittedPts, setAdmittedPts] = useState([]);
    const [startRange, setStartRange] = useState(null);
    const [endRange, setEndRange] = useState(null);

    // Current Site State
    const [currentSite, setCurrentSite] = useState(null);

    const [tempButtons, setTempButtons] = useState([]);

    // Load maps data
    useEffect(() => {
        getZoneAndBedsNameFromOldMapUHD(refContainer, refContainerElement).then(data => {
            setZones(data);
        });
    }, []);

    useEffect(() => {
        setTempButtons([]);
    }, [selectedPatient]);

    // Load Patients
    useEffect(() => {
        const wardsIds = [];
        _.forEach(uhdMaps, hosp => {
            wardsIds.push(`ED##${hosp?.hospitalId}`);
        });
        dispatch(loadWardPatientsByWardId(wardsIds, false, true));

        let opt = {
            admitted: toggleAdmitted,
            start: null,
            end: null,
        };
        if (toggleAdmitted) {
            opt = {
                ...opt,
                start: moment(startRange).utc().set({hour: 0, minute: 0, second: 0}).format(ecdsDateTimeFormat),
                end: moment(endRange).utc().set({hour: 23, minute: 59, second: 59}).format(ecdsDateTimeFormat),
            };
        }

        API.getBedBookingPatients(opt).then(res => {
            let bbPts = _.filter(res, pt => !_.isNull(pt.patient));
            setOtherSitePts(bbPts || []);
        });
    }, [open, toggleAdmitted]);

    useEffect(() => {
        if (toggleAdmitted) {
            const wardsIds = [];
            _.forEach(uhdMaps, hosp => {
                wardsIds.push(`ED##${hosp?.hospitalId}`);
            });

            API.getPatientHistory(
                wardsIds,
                moment(startRange).utc().set({hour: 0, minute: 0, second: 0}),
                moment(endRange).utc().set({hour: 23, minute: 59, second: 59}),
            ).then(r => {
                const filter = _.filter(r, pt => !_.isEmpty(pt?.csmContactedTime) || !_.isEmpty(pt?.studies?.bedRequest));
                setAdmittedPts(filter);
            });
        } else {
            setAdmittedPts([]);
        }
    }, [toggleAdmitted]);

    // Check if patients data changes
    useEffect(() => {
        const UPDATE_FREQUENCY = 3000; // 3 sec
        let interval;

        const wardsIds = [];
        _.forEach(uhdMaps, hosp => {
            wardsIds.push(`ED##${hosp?.hospitalId}`);
        });
        const updateData = () => {
            dispatch(updateWardPatientsByWardId(wardsIds, true));

            let opt = {
                admitted: toggleAdmitted,
                start: null,
                end: null,
            };
            if (toggleAdmitted) {
                opt = {
                    ...opt,
                    start: moment(startRange).utc().set({hour: 0, minute: 0, second: 0}).format(ecdsDateTimeFormat),
                    end: moment(endRange).utc().set({hour: 23, minute: 59, second: 59}).format(ecdsDateTimeFormat),
                };
            }

            API.getBedBookingPatients(opt).then(res => {
                let bbPts = _.filter(res, pt => !_.isNull(pt.patient));
                // setOtherSitePts(bbPts || []);
                if (!_.isEqual(otherSitePts, bbPts)) setOtherSitePts(bbPts);
            });
        };

        interval = setInterval(updateData, UPDATE_FREQUENCY);
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [open, otherSitePts, toggleAdmitted]);

    useEffect(() => {
        if (_.isEmpty(arrivalMode)) {
            let ambulance = [];
            _.forEach(_.filter(dictArrivalMode, {group: 'ambulance'}), element => {
                ambulance.push(element.__code);
            });
            setArrivalMode(ambulance);
        }
    }, [dictArrivalMode]);

    // Init data for table
    useEffect(() => {
        const checkDestination = (pt, isBB) => {
            if (destination === 'both') return true;
            else {
                const destinationName = getFacility(destination);
                const val = isBB ? pt?.csmContactedTime : pt?.studies?.bedRequest;
                let ptFacility = getFacility(pt?.facility);

                if (val?.anotherDestination !== '') {
                    if (_.isBoolean(val?.anotherDestination) && Boolean(val?.anotherDestination)) {
                        ptFacility = pt?.facility === uhdMaps?.[0]?.hospitalId
                            ? getFacility(uhdMaps?.[1]?.hospitalId) : getFacility(uhdMaps?.[0]?.hospitalId);
                    }
                    if (_.isString(val?.anotherDestination)) ptFacility = val?.anotherDestination;
                }
                return destinationName === ptFacility;
            }
        };

        const checkCurrentSite = (pt, isBB) => {
            if (!_.isEmpty(currentSiteFilter)) {
                let facilityName = '';
                if (isBB) {
                    facilityName = 'Offsite';
                    if (pt?.currentSiteBedBooking) {
                        facilityName = pt.currentSiteBedBooking?.__description;
                    }
                } else {
                    const obj = _.find(currentSiteBedBooking, {__code: pt?.facility});
                    facilityName = obj?.__description || 'UNK';
                }
                return facilityName === currentSiteFilter.__description;
            }
            return true;
        };

        const checkSpecialty = (pt, isBB) => {
            if (_.isEmpty(specialty)) return true;
            else {
                let check = false;
                _.forEach(renderReferrals(pt, isBB), ref => {
                    if (check) return;

                    check = _.some(specialty, r => r.snomedCode === ref.snomedCode);
                });
                return check;
            }
        };

        const checkBedStatus = (pt, isBB) => {
            if (_.isEmpty(bedStatus)) return true;
            else {
                const stat = getBedStatus(pt, isBB);
                return stat === bedStatus;
            }
        };

        const ptsObj = [];
        let filteredPt = _.filter(toggleAdmitted ? admittedPts : wardPatientsObject, pt => {
            if (pt?.studies?.bedRequest?.requested && checkDestination(pt) && checkCurrentSite(pt) && checkSpecialty(pt, false) && checkBedStatus(pt, false))
                return pt;
        });
        let filteredOtherPt = _.filter(otherSitePts, pt => {
            if (checkDestination(pt, true) && checkCurrentSite(pt, true) && checkSpecialty(pt, true) && checkBedStatus(pt, true)) return pt;
        });

        if (toggleAdmitted) {
            let all = [];
            if (ptReferred !== 'other') all = [...all, ...filteredPt];
            if (ptReferred !== 'ed') all = [...all, ...filteredOtherPt];

            all = _.orderBy(all, pt => getDate(pt), ['desc']);
            ptsObj.push(...initPtData(all));
        } else {
            filteredPt = _.orderBy(filteredPt, ['facility', pt => getStatusBedOrder(pt), 'admission.startDate'], ['asc', 'asc', 'asc']);
            filteredOtherPt = _.orderBy(filteredOtherPt, [pt => getStatusBedOrder(pt, true)], ['asc']);
            if (ptReferred !== 'other') ptsObj.push(...initPtData(filteredPt, 'normal'));
            if (ptReferred !== 'ed') ptsObj.push(...initPtData(filteredOtherPt, 'bedBooking'));
        }
        setPtsObject(ptsObj);
    }, [zones, wardPatientsObject, otherSitePts, triageDependencies, sdecSitesDict, ptReferred, specialty, bedStatus, destination, toggleAdmitted, admittedPts, currentSiteFilter]);

    const initPtData = (ptsArrays, type) => {
        const ptArray = [];
        _.forEach(ptsArrays, (pt, index) => {
            let ptType = type;
            if (!type) {
                const type = pt?.__type?.split('.');
                ptType = type[type.length - 1] === 'BedBooking' ? 'bedBooking' : 'normal';
            }

            const ptName = `${pt?.patient?.firstName} ${pt?.patient?.familyName}`;
            let age = moment().diff(pt.patient.dob, 'years');
            if (age === 0) age = moment().diff(pt.patient.dob, 'months') + 'M';
            else age = age + '';

            function getBed() {
                if (pt?.bedDescription) return pt?.bedDescription;
                if (pt?.bed) {
                    if (_.startsWith(pt?.bed, 'nrbh')) return pt?.bed.substring(4).toUpperCase();
                    return _.startsWith(pt?.bed, 'rbh') ? pt?.bed.substring(3).toUpperCase() : pt?.bed.toUpperCase();
                }
                return 'WLIST1';
            }

            const isBB = ptType === 'bedBooking';

            ptArray.push({
                __id: uuidv4() + '',
                __type: ptType,
                count: getCountStatus(ptsArrays, pt, isBB),
                link: getLink(pt, isBB),
                ptName,
                hospNo: pt?.patient?.__id || 'UNK',
                gender: pt?.patient?.gender || 'UNK',
                age,
                obs: pt?.patient?.lastObservation?.totalScore,
                type: isBB ? 'Non ED' : 'ED',
                site: getSite(pt, false, isBB),
                zone: getZone(pt, isBB),
                bed: ptType === 'bedBooking' ? '' : getBed(),
                time: ptType === 'bedBooking' ? null : calculateArrivalDate(pt),
                timeReferral: getTimeRef(pt, isBB),
                timeReady: getTimeReady(pt, isBB),
                timeBedWait: getTimeWait(pt, isBB),
                destination: getSite(pt, true, isBB),
                speciality: getReferrals(pt, isBB),
                activity: getActivity(pt, isBB),
                resForAdmit: getCSM('resForAdmit', pt, isBB),
                patientPost: getCSM('patientPost', pt, isBB),
                dependency: getDependency(pt, isBB),
                sideRoom: getCSM('sr', pt, isBB),
                ward: getCSM('ward', pt, isBB),
                infections: getInfections(pt, isBB),
                onHoldWard: getCSM('onHoldWard', pt, isBB),
                edNote: getCSM('edNote', pt, isBB),
                wardFeedback: getCSM('wardFeedback', pt, isBB),
                withinHour: getCSM('withinHour', pt, isBB),
                status: getCSM('bed', pt, isBB),
                conclusion: getClinicalConclusion(pt, isBB),
                readyNote: getCSM('readyNote', pt, isBB),
                canceledNote: getCSM('canceledNote', pt, isBB),
                onHoldWardNote: getCSM('onHoldWardNote', pt, isBB),
                patientPostNote: getCSM('patientPostNote', pt, isBB),
                timestamp: getDate(pt, isBB),
            });
        });
        return ptArray;
    };

    const getLink = (pt, isBB) => {
        if (isBB) {
            return (
                <IconButton
                    size="small"
                    onClick={handleRemoveBBPt.bind(this, pt)}
                    disableRipple
                    style={{position: 'inherit'}}
                >
                    <PersonRemoveIcon fontSize="small"/>
                </IconButton>
            );
        }

        return (
            <IconButton
                size="small"
                onClick={handleOpenPatient.bind(this, pt)}
                disableRipple
                style={{position: 'inherit'}}
            >
                <ContactPageIcon fontSize="small"/>
            </IconButton>
        );
    };

    function getStatusBedOrder(pt, isBB) {
        let status = 2;
        const form = isBB ? pt?.csmContactedTime : pt?.studies?.bedRequest;

        if (form?.requested) status = 2;
        if (form?.allocated) status = 3;
        if (form?.ready) status = 1;
        if (form?.canceled) status = 4;
        return status;
    }

    function getDate(pt, isBBFlag) {
        const type = pt?.__type?.split('.');
        const isBB = isBBFlag ? isBBFlag : type[type.length - 1] === 'BedBooking';

        return isBB ? pt?._lastModifiedDate : pt?.admission?.endDate;
    }

    const getZone = (pt, isBB) => {
        if (isBB) {
            const handleChange = (_e, val) => {
                let valMap = val;
                if (val) {
                    valMap = {
                        ...valMap,
                        _id: valMap.__id,
                        description: valMap.__description,
                    };
                }
                handleSaveBBData([{
                    name: 'sdecSite',
                    value: valMap,
                }], pt);
            };

            return (
                <AgyleDictionaryField
                    onChange={handleChange}
                    options={_.filter(sdecSitesDict, f => f?.hospitalsId?.includes(pt?.currentSiteBedBooking?.__code))}
                    value={pt?.sdecSite}
                    loading={sdecSitesDictLoading}
                    withBackground={false}
                    textFieldStyle={classes.dictFont}
                    disabled={toggleAdmitted || dispatch(hasPermission(Permissions.AGYLE_CAN_VIEW_ONLY))}
                />
            );
        } else {
            if (pt?.areaDescription) return pt?.areaDescription;
            if (!pt?.bed) {
                return 'WAIT TRIAGE';
            }

            let zoneName = '-';
            _.forEach(zones, zone => {
                if (zoneName !== '-') return;

                _.forEach(zone.beds, zoneBed => {
                    if (zoneName !== '-') return;

                    if (zoneBed?.parsed?.params?.[1] === pt?.bed) {
                        zoneName = handleListName(zone?.areaTitle);
                    }
                });
            });
            return zoneName;
        }
    };

    const getSite = (pt, destination, isBB) => {
        const openCSM = () => {


        };

        let facilityName = '';
        if (isBB) {
            facilityName = 'Offsite';
            if (pt?.currentSiteBedBooking) {
                facilityName = pt.currentSiteBedBooking?.__description;
            }
        } else {
            const obj = _.find(currentSiteBedBooking, {__code: pt?.facility});
            facilityName = obj?.__description || 'UNK';
        }

        if (!_.isEmpty(pt?.facility) && !isBB) facilityName = pt?.facility === uhdMaps?.[0]?.hospitalId ? 'Poole' : 'Bournemouth';

        if (destination) {
            const val = isBB ? pt?.csmContactedTime : pt?.studies?.bedRequest;
            if (isBB) facilityName = pt?.facility === uhdMaps?.[0]?.hospitalId ? 'Poole' : 'Bournemouth';
            if (val?.anotherDestination) facilityName = val.anotherDestination;

            return {
                value: facilityName,
                onClick: checkPermissionToOpenPatient.bind(this, pt, openCSM, isBB),
            };
        }

        return {
            value: facilityName,
            onClick: isBB ? handleOpenCurrentSite.bind(this, pt) : null,
        };
    };

    const renderReferrals = (patient, isBB) => {
        const val = isBB ? patient?.specialty : patient?.studies?.referrals;
        const referrals = [];

        if (!_.isEmpty(dictReferredToService) && !_.isEmpty(val?.ReferralsToOtherServices)) {
            _.forEach(val?.ReferralsToOtherServices, referral => {
                const find = _.find(dictReferredToService, {__id: referral?.ReferredToService_SnomedCt?.__id});
                if (find)
                    referrals.push({
                        id: find.notes,
                        group: find.group,
                        description: find.__description,
                        snomedCode: find.snomedCode,
                        completed: referral.ReferredToServiceAssessmentTime !== '',
                    });
            });
        }

        return referrals;
    };

    const getTimeWait = (pt, isBB) => {
        const val = isBB ? pt?.csmContactedTime : pt?.studies?.bedRequest;
        if (val) {
            return {
                requested: val?.requested ? val?.requestedWhen : null,
                ready: val?.ready ? val?.readyWhen : null,
            };
        } else if (pt?.metadata?.bedRequest) {
            return pt?.metadata?.bedRequest;
        }
        return null;
    };

    const getTimeRef = (pt, isBB) => {
        const val = isBB ? pt?.specialty : pt?.studies?.referrals;

        if (!_.isEmpty(val?.ReferralsToOtherServices)) {
            let firstRef = null;
            _.forEach(val?.ReferralsToOtherServices, referral => {
                const localReq = UtilsMomentJS.getLocalDateFromUTCECDSFormat(referral.ActivityServiceRequestDate_EmergencyCare, referral.ActivityServiceRequestTime_EmergencyCare);
                if (!firstRef || moment(firstRef).isAfter(localReq)) firstRef = localReq;
            });
            return firstRef;
        }
        return null;
    };

    const getTimeReady = (pt, isBB) => {
        const val = isBB ? pt?.csmContactedTime : pt?.studies?.bedRequest;

        if (val?.ready && !val?.canceled) {
            return val?.readyWhen ? moment(val?.readyWhen) : null;
        }
        return null;
    };

    const handleOpenReferrals = (pt, isBB) => {
        if (diagnosisRequiredDialog && !isBB) {
            if (_.isEmpty(pt?.diagnosis?.primary) && !pt?.metadata?.diagnosisNotRequired?.acknowledge)
                openEmptyDiagnosisDialog();
            else
                openReferrals();
        } else {
            openReferrals();
        }
    };

    const getReferrals = (pt, isBB) => {
        const refs = renderReferrals(pt, isBB);
        let val = (
            <Fragment>
                {refs.map((ref, index) => (
                    <Tooltip
                        key={index}
                        title={ref.description}
                    >
                        <div
                            style={{backgroundColor: getReferralsColor(ref)}}
                            className={clsx(classes.referral, ref.completed && 'completed')}
                        >
                            {ref.id}
                        </div>
                    </Tooltip>
                ))}
            </Fragment>
        );
        return {
            value: val,
            onClick: checkPermissionToOpenPatient.bind(this, pt, () => handleOpenReferrals(pt, isBB), isBB),
        };
    };

    const getBedStatus = (pt, isBB) => {
        const val = isBB ? pt?.csmContactedTime : pt?.studies?.bedRequest;
        let status = isBB ? 'Requested' : '';
        if (val?.requested) status = 'Requested';
        if (val?.allocated) status = 'Allocated';
        if (val?.ready) status = 'Ready';
        if (val?.canceled) status = 'Canceled';

        return status;
    };

    const getCSM = (type, pt, isBB) => {
        const form = isBB ? pt?.csmContactedTime : pt?.studies?.bedRequest;
        let val = '';

        // eslint-disable-next-line default-case
        switch (type) {
            case 'ward':
                if (form?.ward) {
                    val = `${_.startCase(form?.ward?.wardName?.toLowerCase())}`;
                }
                break;
            case 'bed':
                val = getBedStatus(pt, isBB);
                break;
            case 'edNote':
                val = form?.requestedNote || '';
                break;
            case 'wardFeedback':
                val = form?.allocatedNote || '';
                break;
            case 'resForAdmit':
                val = form?.reasonForAdmissions || '';
                break;
            case 'sr':
                let srValue = false;
                if (isBB) {
                    srValue = form?.sideRoom;
                } else {
                    srValue = getPatientFlagValue(pt, 'sr');
                }
                const note = !_.isEmpty(form?.sideRoomNote) ? `(${form.sideRoomNote})` : '';
                val = (
                    <div style={{textAlign: 'left'}}>
                        {srValue ? 'Yes' : 'No'}
                        {note &&
                            <>
                                <br/>
                                <span>{note}</span>
                            </>
                        }
                    </div>
                );
                break;
            case 'withinHour':
                const wh = form?.withinHour;
                if (wh && form?.withinHourTimestamp) {
                    const time = moment(form?.withinHourTimesToTrack);
                    val = (
                        <b
                            style={time.isBefore(moment()) ? {
                                color: 'red',
                                fontWeight: 600,
                            } : time.diff(moment(), 'minutes') < 15 ? {
                                color: 'coral',
                                fontWeight: 600,
                            } : {}}
                        >
                            <TimerCountUp
                                time={time}
                                limit={0}
                                upperLimit={1}
                                limitMessage={t('Times out!')}
                                countDown
                            />
                            <span>{form?.withinHourNote ? ` (${form?.withinHourNote})` : ''}</span>
                        </b>
                    );
                } else {
                    val = `No${!_.isEmpty(form?.withinHourNote)
                        ? ` (${form?.withinHourNote || 'N/D'})`
                        : ''}`;
                }
                break;
            case 'readyNote':
                val = form?.readyNote || '';
                break;
            case 'canceledNote':
                val = form?.canceledNote || '';
                break;
            case 'onHoldWard':
                val = form?.onHoldWard ? 'Yes' : 'No';
                break;
            case 'onHoldWardNote':
                val = form?.onHoldWardNote || '';
                break;
            case 'patientPost':
                val = form?.patientPost ? 'Yes' : 'No';
                break;
            case 'patientPostNote':
                val = form?.patientPostNote || '';
                break;
        }
        return {
            value: val,
            onClick: checkPermissionToOpenPatient.bind(this, pt, openCSM, isBB),
        };
    };

    const getClinicalConclusion = (pt, isBB) => {
        let val;
        switch (pt?.clinicalConclusion?.status) {
            case 'Deceased':
                val = 'Deceased';
                break;
            case 'Admitted':
                val = 'Ready to Admit to Ward';
                break;
            case 'Transfer':
                val = 'Ready to Transfer';
                break;
            case 'Discharge':
                val = 'Ready to Discharge';
                break;
            default:
                val = 'No Clinical Conclusion';
        }
        return {
            value: val,
            onClick: checkPermissionToOpenPatient.bind(this, pt, openClinicalConclusion, isBB),
        };
    };

    const getInfections = (pt, isBB) => {
        let obj = pt?.metadata;

        if (isBB) {
            obj = {infections: {}};
            if (pt?.alarms && !_.isEmpty(pt?.alarms[1])) {
                _.forEach(pt?.alarms[1], al => {
                    obj = {
                        infections: {
                            ...obj.infections,
                            ...al,
                        },
                    };
                });
            }
        }

        let val = getInfectionIcon(obj, clsx(classes.topIcon, classes.centerRow), false, true, false);
        const openAlarms = () => {
            if (!toggleAdmitted) {
                setSelectedPatient(pt);
                saveType.current = isBB ? 'bb' : 'normal';
                openAlarm();
            }
        };

        if (!val && !isBB && obj?.alertsCount?.count && obj?.alertsCount?.count > 0) {
            val = (
                <div className={clsx(classes.topIcon, classes.centerRow)}>
                    <NotificationsIcon/>
                </div>
            );
        }

        return {
            value: val,
            onClick: openAlarms,
        };
    };

    const getActivity = (pt, isBB) => {
        let form = isBB ? _.cloneDeep(pt?.csmContactedTime) : _.cloneDeep(pt?.studies?.bedRequest);
        form = !_.isEmpty(form) ? form : {};

        const handleChangeDict = (value) => {
            form.activityTreatment = value;
            if (isBB) {
                handleSaveBBData([{
                    name: 'csmContactedTime',
                    value: form,
                }], pt);
            } else {
                handleSaveData([{
                    name: 'studies.bedRequest',
                    value: form,
                    noteToAdd: Notes.getBedRequestNote(form),
                }], pt);
            }
        };

        return (
            <AgyleDictionaryField
                onChange={(_e, val) => handleChangeDict(val)}
                options={activityTreatment}
                value={form.activityTreatment}
                loading={activityTreatmentLoading}
                withBackground={false}
                placeholder="Select activity"
                disabled={toggleAdmitted || dispatch(hasPermission(Permissions.AGYLE_CAN_VIEW_ONLY))}
            />
        );
    };

    const getDependency = (pt, isBB) => {
        const getVal = () => {
            if (pt?.triage?.dependency)
                return pt?.triage?.dependency?.__code;

            return '';
        };

        const changeDependency = (val) => {
            const getValObj = _.find(triageDependencies, {__code: val}) || null;

            let clone = _.cloneDeep(pt?.triage);
            if (!clone) {
                clone = {};
            }
            clone.dependency = getValObj;
            if (isBB) {
                handleSaveBBData([{
                    name: 'triage',
                    value: clone,
                }], pt);
            } else {
                handleSaveData([{
                    name: 'triage',
                    value: clone,
                    noteToAdd: Notes.getDependencyChange(getValObj),
                }], pt);
            }
        };

        const renderCustomOption = (opt) => {
            return (
                <MenuItem
                    key={opt.__id}
                    value={opt.__code}
                >
                    <Tooltip title={opt?.__description}>
                        <div
                            className={classes.colorSystem}
                            style={{
                                backgroundColor: opt.color.toLowerCase(),
                            }}
                        />
                    </Tooltip>
                </MenuItem>
            );
        };

        return (
            <AgyleSelectField
                onChange={changeDependency}
                options={triageDependencies}
                value={getVal()}
                customObject={renderCustomOption}
                disabled={toggleAdmitted || dispatch(hasPermission(Permissions.AGYLE_CAN_VIEW_ONLY))}
            />
        );
    };

    const getCountStatus = (allPts, pt, isBB) => {
        const bedStatus = getBedStatus(pt, isBB);

        const filteredPts = _.filter(allPts, p => {
            if (getBedStatus(p, isBB) === bedStatus && (p?.facility === pt?.facility || isBB)) return p;
        });

        return _.findIndex(filteredPts, {__id: pt?.__id}) + 1;
    };

    const checkPermissionToOpenPatient = (pt, openMethod, isBB) => {
        if (!toggleAdmitted) {
            if (dispatch(hasOneOfPermission([Permissions.AGYLE_CAN_OPEN_PATIENT_RECORD, Permissions.AGYLE_CAN_VIEW_ONLY]))) {
                setSelectedPatient(pt);
                openMethod();
                saveType.current = isBB ? 'bb' : 'normal';
            } else {
                dispatch(setSnackbar({type: 'warning', message: t('User has no permission for open patient record.')}));
            }
        }
    };

    const handleChangeDestination = (val) => {
        setDestination(val);
    };

    const handleChangePtRef = (val) => {
        setPtReferred(val);
    };

    const handleChangeSpecialty = (_e, val) => {
        setSpecialty(val);
    };

    const handleChangeSite = (val) => {
        setCurrentSiteFilter(val);
    };

    const handleChangeBedStatus = (val) => {
        setBedStatus(val);
    };

    const renderOption = (opt) => {
        return (
            <MenuItem
                key={opt.__id}
                value={opt}
            >
                {opt.__description}
            </MenuItem>
        );
    };

    const handleRemoveBBPt = (pt) => {
        if (!toggleAdmitted) {
            if (dispatch(hasPermission(Permissions.AGYLE_CAN_REMOVE_FROM_BEDBOOKING))) {
                setSelectedPatient(pt);
                openDischarge();
            } else {
                dispatch(setSnackbar({
                    type: 'warning',
                    message: t('User has no permission for remove patient from bed booking.'),
                }));
            }
        }
    };

    const handleOpenPatient = (pt) => {
        if (!toggleAdmitted) {
            if (dispatch(hasOneOfPermission([Permissions.AGYLE_CAN_OPEN_PATIENT_RECORD, Permissions.AGYLE_CAN_VIEW_ONLY]))) {
                dispatch(sendUserAudit(pt, AUDIT_TYPES.OPEN_PATIENT_CARD));
                history.push(`/patient/attendance/${pt?.admission?.__id}`);
            } else {
                dispatch(setSnackbar({type: 'warning', message: t('User has no permission for open patient record.')}));
            }
        }
    };

    const handleDischargeBB = () => {
        if (selectedPatient) {
            const isCanceled = selectedPatient?.csmContactedTime?.canceled;
            const obj = [{status: isCanceled ? 'CANCELED' : 'FINISHED'}];
            API.updateBedBookingPatients(selectedPatient?.__id, obj)
                .then(res => {
                    if (res) dispatch(setSnackbar({type: 'success', message: 'Patient data saved correctly'}));
                    else dispatch(setSnackbar({type: 'error', message: 'Patient data not saved correctly'}));
                })
                .catch((err) => {
                    dispatch(setSnackbar({type: 'error', message: 'Patient data not saved correctly'}));
                    console.error(err);
                });
            closeDischarge();
            setSelectedPatient(null);
        }
    };

    const mapValueToBB = (val) => {
        let mapVal = {
            value: val.value,
            name: '',
        };
        let name = '';

        switch (val.name) {
            case 'studies.bedRequest':
                name = 'csmContactedTime';
                break;
            case 'studies.referrals':
                name = 'specialty';
                break;

            default:
                name = val.name;
                break;
        }
        mapVal = {
            ...mapVal,
            name,
        };
        return mapVal;
    };

    const handleSave = (val) => {
        if (saveType.current === 'bb') {
            const newVal = [];
            _.forEach(val, v => {
                const mapper = mapValueToBB(v);
                newVal.push(mapper);
            });
            handleSaveBBData(newVal);
        } else {
            handleSaveData(val);
        }
    };

    const handleSaveBBData = (values, patient) => {
        let mod = [];

        values.forEach((val) => mod.push({[val.name]: val.value}));
        const pt = selectedPatient ? selectedPatient : patient;

        API.updateBedBookingPatients(pt?.__id, mod)
            .then(res => {
                if (res) dispatch(setSnackbar({type: 'success', message: 'Patient data saved correctly'}));
                else dispatch(setSnackbar({type: 'error', message: 'Patient data not saved correctly'}));
            })
            .catch((err) => {
                dispatch(setSnackbar({type: 'error', message: 'Patient data not saved correctly'}));
                console.error(err);
            })
            .finally(() => setSelectedPatient(null));
    };

    const handleSaveData = (values, patient) => {
        let mod = [];
        let notes = [];
        console.log('Values', values);
        values.forEach((val) => {
            mod.push({[val.name]: val.value});

            if (val.noteToAdd) notes.push({text: val.noteToAdd, type: val.name});
            if (val.note) notes.push({text: val.note, type: val.noteType});
            if (val.noteToAddWithRefId) {
                _.forEach(val.noteToAddWithRefId, (singleNote) => {
                    notes.push({
                        text: singleNote.noteToAddWithRefId,
                        type: val.name,
                        referenceId: singleNote.referenceId,
                    });
                });
            }
        });
        const pt = selectedPatient ? selectedPatient : patient;
        dispatch(updatePatientData(pt, mod, (status) => {
            if (status) {
                dispatch(addNotesForPatient(pt.__id, pt.patient.__id, pt?.admission?.consultantEpisodeId, notes, (statusNotes) => {
                    popSnackMessage(status, statusNotes);
                }));
            } else {
                popSnackMessage(status, false);
            }
        }));

        setSelectedPatient(null);
    };

    const handleOpenCurrentSite = (pt) => {
        if (!toggleAdmitted && !dispatch(hasPermission(Permissions.AGYLE_CAN_VIEW_ONLY))) {
            setSelectedPatient(pt);
            setCurrentSite(pt?.currentSiteBedBooking || null);
            openCurrentSite();
        }
    };

    const handleCloseCurrentSite = () => {
        setCurrentSite(null);
        closeCurrentSite();
    };

    const handleChangeCurrentSite = () => {
        if (currentSite) {
            const valMap = {
                ...currentSite,
                code: currentSite.__code,
                description: currentSite.__description,
            };

            handleSaveBBData([{
                name: 'currentSiteBedBooking',
                value: valMap,
            }], selectedPatient);
            handleCloseCurrentSite();
        }
    };

    const renderCurrentSiteCheck = () => {
        return (
            <AgyleDictionaryField
                label={t('Patient Location')}
                onChange={(_e, val) => setCurrentSite(val)}
                options={currentSiteBedBooking}
                value={currentSite}
                loading={currentSiteBedBookingLoading}
                withBackground
            />
        );
    };

    const renderMoveText = () => {
        const isCanceled = selectedPatient?.csmContactedTime?.canceled;

        return (
            <span>
                {t(
                    isCanceled ? 'The patient bed booking has been cancelled.'
                        : 'The patient has now moved to their booked bed.',
                )}
            </span>
        );
    };

    const popSnackMessage = (dataStatus, noteStatus) => {
        let message = '';
        let type = 'error';
        if (dataStatus) {
            if (noteStatus) {
                message = 'Patient Data & Note saved correctly!';
                type = 'success';
            } else {
                message = 'Patient Data saved correctly, but Notes were not added!';
            }
        } else {
            message = 'Patient Data & Notes not saved correctly!';
        }
        dispatch(setSnackbar({type: type, message: message}));
    };

    const handleCloseAlarms = (e, reason) => {
        setSelectedPatient(null);
        closeAlarm(e, reason);
    };

    const handleChangeDate = (val, type) => {
        setToggleAdmitted(false);
        if (type === 'startRange') setStartRange(val);
        else setEndRange(val);
    };

    const handleClearRange = () => {
        setStartRange(null);
        setEndRange(null);
        setToggleAdmitted(false);
    };

    const handleReload = () => {
        if (startRange && endRange && moment(startRange).isSameOrBefore(moment(endRange))) setToggleAdmitted(true);
        else dispatch(setSnackbar({type: 'warning', message: t('Select all dates')}));
    };

    return (
        <>
            <AgyleHeader onBack={onClose}>
                <div className={classes.centerRow} style={{marginLeft: 'auto'}}>
                    <FormLabel className={classes.label}>
                        {t('Admitted Date Range')}
                    </FormLabel>

                    <div style={{marginLeft: 10}}>
                        <AgyleDatePicker
                            label={t('From')}
                            onChange={val => handleChangeDate(val, 'startRange')}
                            value={startRange}
                            type="date"
                            maxDate={moment()}
                            noBorder={false}
                            withNewBackground
                        />
                    </div>

                    <div style={{marginLeft: 10}}>
                        <AgyleDatePicker
                            label={t('To')}
                            onChange={val => handleChangeDate(val, 'endRange')}
                            value={endRange}
                            type="date"
                            maxDate={moment()}
                            minDate={startRange}
                            noBorder={false}
                            withNewBackground
                        />
                    </div>

                    <AgyleButton
                        onClick={handleReload}
                        style={{marginLeft: 10}}
                    >
                        {t('Apply')}
                    </AgyleButton>

                    <IconButton
                        disableRipple={true}
                        onClick={handleClearRange}
                        size='small'
                    >
                        <ClearIcon
                            fontSize="small"
                        />
                    </IconButton>
                </div>
            </AgyleHeader>

            {toggleAdmitted &&
                <InformationBox type="warning">
                    {t('Caution admitted filter is applied - Not all patients might be displayed.')}
                </InformationBox>
            }

            <Paper className={classes.paper}>
                <Grid container direction="row" spacing={2} columns={10}>
                    <Grid item xs={10} sm={5} md={2}>
                        <AgyleSelectField
                            onChange={handleChangeDestination}
                            options={HOSPITAL_OPT}
                            value={destination}
                            label={t('Destination of Patient')}
                            defaultClearValue="both"
                            withBackground
                            shrink
                            padding="8px"
                        />
                    </Grid>

                    <Grid item xs={10} sm={5} md={2}>
                        <AgyleSelectField
                            onChange={handleChangePtRef}
                            options={PT_OPT}
                            value={ptReferred}
                            label={t('Patient Referred From')}
                            defaultClearValue="both"
                            withBackground
                            shrink
                            padding="8px"
                        />
                    </Grid>

                    <Grid item xs={10} sm={5} md={2}>
                        <AgyleSelectField
                            onChange={handleChangeSite}
                            options={currentSiteBedBooking}
                            value={currentSiteFilter}
                            customObject={renderOption}
                            label={t('Current Site')}
                            withBackground
                            shrink
                            selectedField="__description"
                            padding="8px"
                        />
                    </Grid>

                    <Grid item xs={10} sm={5} md={2}>
                        <ReferredToService
                            label={t('Speciality')}
                            onChange={handleChangeSpecialty}
                            value={specialty}
                            isMultiple
                            textFieldStyle={classes.textFieldStyle}
                            shrink
                            limitTags={1}
                            disableCloseOnSelect
                        />
                    </Grid>

                    <Grid item xs={10} sm={5} md={2}>
                        <AgyleSelectField
                            onChange={handleChangeBedStatus}
                            options={BED_STATUS_OPT}
                            value={bedStatus}
                            label={t('Bed status')}
                            withBackground
                            shrink
                            padding="8px"
                        />
                    </Grid>
                </Grid>
            </Paper>

            <Paper className={classes.paper}>
                <AgyleTable
                    disableFilter
                    columns={toggleAdmitted ? [...TIMESTAMP, ...BOOKING_COLUMNS] : BOOKING_COLUMNS}
                    data={ptsObject}
                    customizableColumnsPath="bedBookingColumnOrder"
                />
            </Paper>

            {isCSMOpen &&
                <MiniFormDialog
                    title={t(getCSMFormName())}
                    open={isCSMOpen}
                    onClose={closeCSM}
                    disableSave
                    buttons={tempButtons}
                >
                    {patientBanner(selectedPatient, true)}
                    <CsmFrom
                        open={isCSMOpen}
                        patient={selectedPatient}
                        onSave={handleSave}
                        onClose={closeCSM}
                        isBB={saveType.current === 'bb'}
                        disableSave={dispatch(hasPermission(Permissions.AGYLE_CAN_VIEW_ONLY))}
                        agyleDialogInsertButtons={(btn) => setTempButtons(btn)}
                    />
                </MiniFormDialog>
            }

            <ClinicalConclusion
                _formTitle={t('Clinical Conclusion')}
                patient={selectedPatient}
                open={isClinicalConclusionOpen}
                onSave={handleSave}
                onClose={closeClinicalConclusion}
                disableSubmit={dispatch(hasPermission(Permissions.AGYLE_CAN_VIEW_ONLY))}
                isBB={saveType.current === 'bb'}
                patientInfo
            />

            {selectedPatient && isAlarmOpen &&
                <PatientAlarms
                    patient={selectedPatient?.patient}
                    open={isAlarmOpen}
                    spellId={selectedPatient?.__id}
                    close={handleCloseAlarms}
                    fromBooking
                    isBB={saveType.current === 'bb'}
                    patientBB={selectedPatient}
                    disableSave={dispatch(hasPermission(Permissions.AGYLE_CAN_VIEW_ONLY))}
                    patientInfo
                />
            }

            <ReferralsForm
                open={isReferralsOpen}
                patient={selectedPatient}
                onChange={handleSave}
                close={closeReferrals}
                isBB={saveType.current === 'bb'}
                disableSave={dispatch(hasPermission(Permissions.AGYLE_CAN_VIEW_ONLY))}
                modal
                patientInfo
            />

            <EmptyDiagnosisDialog
                open={isEmptyDiagnosisDialogOpen}
                onClose={closeEmptyDiagnosisDialog}
                onSave={handleSave}
                patient={selectedPatient}
            />

            <MessageBox
                title={t('Move Patient')}
                haveAccept={{yes: t('Submit'), no: t('Close')}}
                onAccept={handleDischargeBB}
                onClose={closeDischarge}
                messageObject={renderMoveText()}
                open={isDischargeOpen}
            />

            <MessageBox
                open={isCurrentSiteOpen}
                title={t('Edit Patient Current Site')}
                haveAccept={{yes: t('Submit'), no: t('Close')}}
                onAccept={handleChangeCurrentSite}
                onClose={handleCloseCurrentSite}
                messageObject={renderCurrentSiteCheck()}
            />

            <div ref={refContainer}/>
        </>
    );
};

export default BedBookingTable;